var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7656",
    "data-name": "Group 7656",
    transform: "translate(-1770 -110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6678",
    "data-name": "Rectangle 6678",
    width: 50,
    height: 50,
    rx: 6,
    transform: "translate(1770 110)",
    fill: "#e5e8eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7682",
    "data-name": "Group 7682",
    transform: "translate(1783 123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    "data-name": "Path 3632",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M5.4,21.6a3,3,0,0,1-3-3V5.4a3,3,0,0,1,3-3H9.527a1,1,0,0,1,1,1,1.116,1.116,0,0,1-1,1.123h-4a1,1,0,0,0-1,1V18.477a1,1,0,0,0,1,1H18.4a1,1,0,0,0,1-1v-4a1.173,1.173,0,0,1,1.186-1,1,1,0,0,1,1,1V18.6a3,3,0,0,1-3,3Zm10.175-7.521a.709.709,0,0,1-.422-.652V11.082q-.282-.015-.565-.014c-1.915,0-5.318.351-6.641,2.707a.682.682,0,0,1-.6.355.662.662,0,0,1-.179-.024.7.7,0,0,1-.51-.677A8.483,8.483,0,0,1,8.939,7.911a8.925,8.925,0,0,1,6.211-2.48V3.11a.7.7,0,0,1,.422-.647.685.685,0,0,1,.753.15l5.055,5.16a.711.711,0,0,1,0,1l-5.055,5.159a.688.688,0,0,1-.753.151Zm.151-4.519a.621.621,0,0,1,.545.625v1.162L19.289,8.27,16.276,5.193V6.36a.625.625,0,0,1-.618.624,7.051,7.051,0,0,0-5.263,1.852,5.821,5.821,0,0,0-1.273,2.042,9.982,9.982,0,0,1,5.422-1.369c.7,0,1.156.053,1.18.053Z",
    transform: "translate(0 0)",
    fill: "#242424"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.fbb833158cc1f275f6d0172b2c21a7a2.svg";
export { ForwardRef as ReactComponent };